import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {AlertModule} from 'ng2-bootstrap';

import {AppComponent} from './app.component';
import {Routes, RouterModule} from "@angular/router";
import {QuestionsTableComponent} from './questions-table/questions-table.component';
import {PlayerTableComponent} from './players-table/players-table.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {PlayerDetailComponent} from './player-detail/player-detail.component';
import {LoginBoxComponent} from './login-box/login-box.component';
import {CanActivateViaAuthGuard} from "./can-activate-via-auth.guard";
import {AuthService} from "./auth.service";
import {WelcomeComponent} from './welcome/welcome.component';
import { QrcodeComponent } from './qrcode/qrcode.component';
import { SettingsComponent } from './settings/settings.component';
import { PlayerFilterPipe } from './player-filter.pipe';
import { TopListComponent } from './top-list/top-list.component';
import {TopListService} from "./top-list.service";
import {QuizzesTableComponent} from './quizzes-table/quizzes-table.component';

const appRoutes: Routes = [
  {path: 'welcome', component: WelcomeComponent, canActivate: [CanActivateViaAuthGuard]},
  {path: 'admin/questions/:quizID', component: QuestionsTableComponent, canActivate: [CanActivateViaAuthGuard]},
  {path: 'admin/questions', component: QuestionsTableComponent, canActivate: [CanActivateViaAuthGuard]},
  {path: 'admin/quizzes', component: QuizzesTableComponent, canActivate: [CanActivateViaAuthGuard]},
  {path: 'admin/players', component: PlayerTableComponent, canActivate: [CanActivateViaAuthGuard]},
  {path: 'admin/players/:playerID', component: PlayerTableComponent, canActivate: [CanActivateViaAuthGuard]},
  {path: 'admin/settings', component: SettingsComponent, canActivate: [CanActivateViaAuthGuard]},
  {path: 'admin/top', component: TopListComponent, canActivate: [CanActivateViaAuthGuard]},
  {path: 'login', component: LoginBoxComponent},
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {path: '**', component: PageNotFoundComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    QuestionsTableComponent,
    QuizzesTableComponent,
    PlayerTableComponent,
    PageNotFoundComponent,
    PlayerDetailComponent,
    LoginBoxComponent,
    WelcomeComponent,
    QrcodeComponent,
    SettingsComponent,
    PlayerFilterPipe,
    TopListComponent
  ],
  imports: [
    AlertModule.forRoot(),
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes),
  ],
  providers: [
    CanActivateViaAuthGuard,
    AuthService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts